import ParrotSpinner from "@/components/ParrotSpinner";
import { useEffect, useState } from "react";

interface LoadingPageProps {
  className?: string;
  spinnerSize?: string;
  onLoadComplete?: () => void;
  showText?: boolean;
}

const loadingMessages = [
  "800 people learning Spanish on Parrot this week 🇪🇸",
  "You're joining thousands learning Spanish the smarter way 🧠",
  "24 million people around the world are learning Spanish - you're next 🌍",
  "Every scroll gets you closer to fluent 🥰",
  "Get ready to speak Spanish with confidence 💪",
  "Swipe up to skip an activity.",
  "Replay lessons until you know at least 80% of the words.",
  "Highlight multiple words to translate full phrases.",
  "Found a great phrase? Highlight it and save it to your dictionary.",
  "Head to the dictionary page to review the words you've collected.",
  "Listening is the fastest way to boost your speaking skills!",
  "The more you listen, the more vocab you pick up without even trying.",
  "Don't stress about understanding everything, just keep the audio going.",
  "Repeat clips you like. Repetition locks the phrases into your brain.",
];

export const LoadingPage = ({
  className,
  spinnerSize,
  onLoadComplete,
  showText = true,
}: LoadingPageProps) => {
  const MINIMUM_DISPLAY_TIME = 7000;
  const [message, setMessage] = useState<string>("");
  const [pageVisible, setPageVisible] = useState(false);

  useEffect(() => {
    // select a random message
    const randomIndex = Math.floor(Math.random() * loadingMessages.length);
    setMessage(loadingMessages[randomIndex]);

    setPageVisible(true);

    const minTimeTimer = setTimeout(() => {
      if (onLoadComplete) {
        fadeOut();
      }
    }, MINIMUM_DISPLAY_TIME);

    return () => {
      clearTimeout(minTimeTimer);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLoadComplete]);

  const fadeOut = () => {
    setPageVisible(false);
    setTimeout(() => {
      if (onLoadComplete) onLoadComplete();
    }, 500);
  };

  return (
    <div
      className={`w-full h-full flex flex-col justify-center items-center transition-opacity duration-500 ${
        pageVisible ? "opacity-100" : "opacity-0"
      } ${className}`}
    >
      <ParrotSpinner size={spinnerSize} />
      {showText && <div className="mt-6 text-center w-64 px-4">{message}</div>}
    </div>
  );
};
